import styles from './style.module.scss';

interface Props {
    data: any[] | undefined;
};

export default function Education(props: Props) {
    const { data } = props;
    const copyOfData = (data && Array.isArray(data)) ? [...data] : null;
    const sortByDate = copyOfData ? copyOfData.sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime()) : null;

    return (
        <div className={styles.wrapper}>
            {data && data.length === 0 && <span>No education experience.</span>}
            {sortByDate?.map((item, indx) => <div className={styles.content}>
                <div className={styles.content_headbar}>
                    <span className={styles.content_headbar_title}>Degree {indx + 1}</span>
                </div>
                <div className={styles.content_main}>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>School  or university</span>
                        <span className={styles.content_main_row_val}>{item.universityName}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Degree</span>
                        <span className={styles.content_main_row_val}>{item.degree}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Field of study</span>
                        <span className={styles.content_main_row_val}>{item.field}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Overal result (GPA)</span>
                        <span className={styles.content_main_row_val}>{item.GPA}</span>
                    </div>
                    <div className={styles.content_main_row}>
                        <span className={styles.content_main_row_prop}>Date</span>
                        <span className={styles.content_main_row_val}>{item.from} - {item.to || 'Present'}</span>
                    </div>
                </div>
            </div>)}
        </div>
    )
};
